<template>      
  <div class="container">
  <md-card class="customCard navbar-margin">
    <md-card-content>
      <h2 class="title">Impressum</h2>
        <div class="md-layout" style="padding: 20px; padding-right: 50px;">
          <div class="md-layout-item">
            <h4 class="title">Balkon &amp; Zaun-Profi<br>Leibhammer + Rietz GmbH</h4> 
            <p>Schlehenweg 5 <br> 73557 Mutlangen</p>
            <p>Telefon: 0172 - 7108977</p>
            <p>E-Mail: info(at)rietz.gmbh <br> Internet: www.leibhammer-rietz.de</p>
            <p><b>Registergericht:</b> Schw&auml;bisch Gm&uuml;nd<br><b>Registernummer:</b> HRB 742584</p>
            <p><b>Geschäftsführer:</b> Frank-Rüdiger Rietz</p>
            <p><b>Steuernummer:</b> 83085/27066 <br> 
              <b>Umsatzsteuer-Identifikationsnummer <br> gemäß § 27 a Umsatzsteuergesetz:</b> DE 157484590</p> 
          </div>
          <div class="md-layout-item">
            <h4 class="title">Urheberrecht</h4> 
            <p>Der Inhalt dieser Webseite, insbesondere alle Texte, Bilder, Grafiken, Logos, Scripts und Downloadmaterialien sind urheberrechtlich geschützt. 
              Ohne die vorherige schriftliche Einwilligung des jeweiligen Urhebers darf diese Homepage weder ganz noch teilweise bearbeitet, vervielfältigt, verbreitet, gesendet, unkörperlich wiedergegeben und auch nicht auf ein elektronisches, magnetisches oder optisches Medium kopiert werden. 
              Davon ausgenommen ist Ihre nicht exklusive Befugnis, die Homepage selbst zu nutzen und einzelne Ausdrucke zum eigenen Gebrauch herzustellen. 
              Sie verpflichten sich alles zu unterlassen, was geeignet ist, Ihnen selbst oder anderen die Nachahmung der Homepage, des Aufbaues des Layouts oder die Darstellung einzelner Produkte zu ermöglichen. 
              Die Darstellung unserer Homepage innerhalb eines „fremden“ Frames ist ausdrücklich untersagt. </p>
            <h4 class="title">Verweise und externe Links</h4> 
            <p>Diese Website enthält Verknüpfungen zu Webseiten Dritter ( externe Links“), auf deren Inhalt die Balkon &amp; Zaun-Profi Leibhammer + Rietz GmbH keinen Einfluss hat und für die die Balkon und Zaunprofi Leibhammer &amp; Rietz GmbH aus diesem Grund keine Gewähr übernimmt.
              Für die Inhalte und Richtigkeit der Informationen ist der jeweilige Informationsanbieter der verlinkten Webseite verantwortlich. 
              Zum Zeitpunkt der Verlinkung waren für die Balkon &amp; Zaun-Profi Leibhammer + Rietz GmbH keine Rechtsverstöße erkennbar. 
              Eine umgehende Entfernung des jeweiligen Links erfolgt ab dem Zeitpunkt der Kenntniserlangung von einer konkreten Rechtsverletzung auf der verlinkten Website.</p>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
export default {
  name: 'Impressum',
  props: {
    msg: String
  },
  data() {
    return {
    }
  },
  methods: {
    onResponsiveInverted() {
      if (window.innerWidth < 600) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
